const user = state => state.user
const users = state => state.users
const isAuthorised = state => state.isAuthorised

export default {
  user,
  users,
  isAuthorised
}
